export default __webpack_public_path__ + "static/media/sn24.924e6994.jpg";